export function findCommonObjects(array1, array2) {
  const commonObjects = array1.filter((obj1) =>
    array2.some((obj2) => obj1.id === obj2.id)
  );

  return commonObjects;
}
